/**
 * Shared portal formatters. `formatPortalDate` covers the date-only strings the
 * portal API returns (notices' `received_on`/`response_deadline`, proforma
 * `invoice_date`, required-doc `due_date`) — the `T00:00:00` suffix anchors them
 * to local midnight so a UTC parse can't shift the day. Published documents carry
 * a full ISO datetime (`created_at`) instead; format those with their own helper
 * (see portal-documents), not this one.
 */
export function formatPortalDate(d: string | null): string {
  if (!d) return "—";
  const date = new Date(`${d}T00:00:00`);
  return Number.isNaN(date.getTime())
    ? "—"
    : date.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
}
